<div class="main-container">
  @if (name === 'liva') {
    <div class="liva-container">
      <div class="header">
        <img alt="liva-logo"
          src="assets/img/liva-logo.png" />
        </div>
        <div class="main-content">
          <div class="title">
            {{'title_fnol_liva' | translate}}
          </div>
          <div class="title-desc">
            {{'desc_fnol_liva' | translate}}
          </div>
          <div class="step">
            {{'registration_card' | translate}}
            <div class="sub-step">
              a. {{'policy_report' | translate}}
            </div>
            <div class="sub-step">
              b. {{'photos_angle_wise' | translate}}
            </div>
            <div class="sub-step">
              c. {{'registration_card_fnol' | translate}}
            </div>
            <div class="sub-step">
              d. {{'driving_license_fnol' | translate}}
            </div>
          </div>
          <div class="navigation"
            (click)="navigate()">
            <img alt="liva-claim"
              src="assets/img/liva-claim.svg" />
              <span>{{'submit_claim' | translate}}</span>
            </div>
          </div>
          <div class="footer">
            {{'copyright' | translate: { year: year } }}
          </div>
        </div>
      } @else {
        <div class="default-container">
          <div class="header">
            @if (logoUrl) {
              <img alt="addenda-logo"
                [src]="logoUrl" />
            }
          </div>
          <div class="main-content">
            <div class="content-wrapper">
              <div class="title">
                {{'title_fnol' | translate}}
              </div>
              <div class="title-desc">
                {{'desc_fnol' | translate}}
              </div>
              <div class="step-title">
                {{pageComponents?.ItemValue | translate}}
              </div>
              @if (pageComponents?.value) {
                <div class="step"
                  >
                  @for (slot of pageComponents?.value; track slot) {
                    <div class="sub-step"
                      >
                      <div class="icon-wrapper">
                        <img [src]="baseConfigUrl + slot.ItemValue"
                          alt="sloTIcon" />
                        </div>
                        {{slot.ItemKey | translate}}
                      </div>
                    }
                  </div>
                }
                @if (!isDirectUrl) {
                  <label for="select"
                  class="select-label">{{'get_started_title' | translate}}</label>
                }
                @if (!isDirectUrl) {
                  <div class="select-container"
                    >
                    <xa-select [(ngModel)]="selectedTenant"
                      [config]="config"
                    [options]="options"></xa-select>
                    <button class="proceed-btn"
                      [disabled]="!selectedTenant || !termsAndCondition"
                    (click)="proceed()">{{'submit_fnol' | translate}}</button>
                  </div>
                }
                @if (!isDirectUrl) {
                  <div class="terms-conditions"
                    >
                    <xa-checkbox [(ngModel)]="termsAndCondition"></xa-checkbox>
                    <div class="terms-text">{{'have_read' | translate}} <span class="terms-link"
                    (click)="openTermsAndConditions($event)">{{'terms_and_conditions' | translate}}</span></div>
                  </div>
                }
                @if (isDirectUrl) {
                  <xa-button class="navigation-btn"
                    type="outline"
                    size="lg"
                    (click)="navigate()">
                    <span>{{'submit_fnol' | translate}}</span>
                  </xa-button>
                }
                @if (androidLink || iosLink) {
                  <div class="image-wrapper show-sm"
                    >
                    <span class="get-now"> {{'get_now' | translate}}</span>
                    <div class="img-content">
                      <img class="mobile-screen"
                        alt="mobile-screen"
                        src="assets/img/mobile-screen.svg" />
                        <div class="eclipse-bg show-sm"></div>
                      </div>
                      <div class="store-link show-sm">
                        @if (androidLink) {
                          <a rel="noopener"
                            [href]="androidLink"
                            target="_blank"><img alt="play-store"
                          src="assets/img/googleplay.png" /></a>
                        }
                        @if (iosLink) {
                          <a rel="noopener"
                            [href]="iosLink"
                            target="_blank"><img alt="app-store"
                          src="assets/img/appstore.png" /></a>
                        }
                      </div>
                    </div>
                  }
                </div>
                @if (androidLink || iosLink) {
                  <div class="image-wrapper hide-sm"
                    >
                    <span class="get-now"> {{'get_now' | translate}}</span>
                    <img class="mobile-screen"
                      alt="mobile-screen"
                      src="assets/img/mobile-screen.svg" />
                      <div class="store-link">
                        @if (androidLink) {
                          <a rel="noopener"
                            [href]="androidLink"
                            target="_blank"
                            ><img alt="play-store"
                          src="assets/img/googleplay.png" /></a>
                        }
                        @if (iosLink) {
                          <a rel="noopener"
                            [href]="iosLink"
                            target="_blank"
                            ><img alt="app-store"
                          src="assets/img/appstore.png" /></a>
                        }
                      </div>
                    </div>
                  }
                </div>
                <div class="footer">
                  {{ 'copyright_reserved' | translate: { year: year } }}
                </div>
                @if (androidLink || iosLink) {
                  <div class="eclipse-bg hide-sm"
                  ></div>
                }
              </div>
            }


          </div>